(function () {
  var drawer = document.querySelector('[data-search-drawer]');
  if (!drawer) return;

  var form = drawer.querySelector('[data-search-form]');
  var input = drawer.querySelector('[data-search-input]');
  var results = drawer.querySelector('[data-search-results]');
  var hint = drawer.querySelector('[data-search-hint]');
  var announce = drawer.querySelector('[data-search-announce]');
  var minChars = Number(drawer.dataset.minChars) || 2;
  var limit = Math.min(Number(drawer.dataset.limit) || 6, 10);

  var previousFocus;
  var previousOverflow;
  var timer;
  var controller;
  var requested = '';
  var rendered = '';
  var cache = Object.create(null);

  // Même précaution que assets/cart-drawer.js : sans preview_theme_id, le rendu
  // de section revient du thème publié et non du brouillon consulté. Aucun
  // identifiant de boutique en dur.
  function contextURL(path) {
    var url = new URL(path, window.location.origin);
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    var theme = window.Shopify && window.Shopify.theme;
    if (!preview && theme && theme.role !== 'main') preview = theme.id;
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }

  // Deux formes de résultat : la ligne de collection, qui porte data-search-result,
  // et la carte produit, rendue par snippets/product-card.liquid — un snippet
  // partagé, auquel on n'ajoute pas d'attribut pour les besoins du tiroir. Les
  // flèches et la touche Entrée parcourent donc les deux par cette liste unique.
  var ROW_SELECTOR = '[data-search-result], .search-drawer__card';
  var ACTIVE_SELECTOR = '[data-search-result][data-active], .search-drawer__card[data-active]';

  function rows() {
    return Array.from(results.querySelectorAll(ROW_SELECTOR));
  }

  function clearActive() {
    rows().forEach(function (row) { row.removeAttribute('data-active'); });
  }

  function setState(open) {
    input.setAttribute('aria-expanded', String(open));
  }

  function reset() {
    if (controller) { controller.abort(); controller = null; }
    clearTimeout(timer);
    requested = '';
    rendered = '';
    results.textContent = '';
    results.removeAttribute('aria-busy');
    if (hint) hint.hidden = false;
    setState(false);
  }

  // Le panneau descend du bas de la barre du header, dont la hauteur varie :
  // bandeau d'annonce affiché ou non, 30px ou 35px sous 478px, barre escamotée
  // au-delà de 500px de défilement. Elle est donc mesurée, jamais écrite en dur.
  // Si la barre est déjà remontée, le bas mesuré est négatif : le panneau part
  // alors du haut de l'écran, ce que le clamp à 0 garantit.
  function syncOffset() {
    var bar = document.querySelector('.site-header__bar');
    if (!bar) return;
    var bottom = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    drawer.style.setProperty('--search-offset', bottom + 'px');
  }

  function open(returnFocus) {
    if (drawer.hasAttribute('data-open')) return;
    syncOffset();
    previousFocus = returnFocus || document.activeElement;
    previousOverflow = document.body.style.overflow;
    drawer.inert = false;
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    input.focus();
    input.select();
  }

  function close() {
    if (!drawer.hasAttribute('data-open')) return;
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    document.body.style.overflow = previousOverflow || '';
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  }

  // Le HTML vient de Shopify, mais on n'injecte jamais une réponse brute : seul
  // le conteneur attendu est repris, ce qui écarte au passage l'enveloppe
  // shopify-section-* et tout script que la réponse contiendrait.
  function render(html, terms) {
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-count]');
    results.textContent = '';
    if (fresh) results.appendChild(fresh);
    rendered = terms;
    results.removeAttribute('aria-busy');
    if (hint) hint.hidden = true;
    var count = fresh ? Number(fresh.dataset.searchCount) : 0;
    setState(count > 0);
    if (announce) {
      announce.textContent = count > 0
        ? count + (count > 1 ? ' résultats' : ' résultat')
        : 'Aucun résultat pour « ' + terms + ' ».';
    }
  }

  function showError() {
    results.textContent = '';
    var message = document.createElement('p');
    message.className = 'search-drawer__empty';
    message.textContent = 'La recherche est momentanément indisponible. Réessayez dans un instant.';
    results.appendChild(message);
    results.removeAttribute('aria-busy');
    if (hint) hint.hidden = true;
    rendered = '';
    setState(false);
  }

  async function search(terms) {
    if (cache[terms]) { render(cache[terms], terms); return; }

    var url = contextURL(drawer.dataset.predictiveUrl);
    url.searchParams.set('q', terms);
    url.searchParams.set('resources[type]', 'product,collection');
    url.searchParams.set('resources[limit]', String(limit));
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('section_id', drawer.dataset.resultsSection);

    if (controller) controller.abort();
    controller = new AbortController();
    var signal = controller.signal;
    results.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(url.href, { signal: signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Predictive search failed');
      var html = await response.text();
      // Une réponse arrivée après que le champ a changé ne doit rien remplacer.
      if (signal.aborted || terms !== requested) return;
      cache[terms] = html;
      render(html, terms);
    } catch (error) {
      if (error.name === 'AbortError' || terms !== requested) return;
      showError();
    }
  }

  function onInput() {
    var terms = input.value.trim();
    requested = terms;
    clearTimeout(timer);
    if (terms.length < minChars) {
      if (controller) { controller.abort(); controller = null; }
      results.textContent = '';
      results.removeAttribute('aria-busy');
      rendered = '';
      if (hint) hint.hidden = false;
      setState(false);
      return;
    }
    if (terms === rendered) return;
    timer = setTimeout(function () { search(terms); }, 250);
  }

  function move(step) {
    var list = rows();
    if (!list.length) return;
    var index = list.findIndex(function (row) { return row.hasAttribute('data-active'); });
    var next = index === -1 ? (step > 0 ? 0 : list.length - 1) : (index + step + list.length) % list.length;
    clearActive();
    list[next].setAttribute('data-active', '');
    list[next].scrollIntoView({ block: 'nearest' });
  }

  input.addEventListener('input', onInput);
  results.addEventListener('pointerdown', clearActive);

  // Entrée reste dans le tiroir : elle ouvre la ligne visée, ou la première de
  // la liste. La page de résultats native n'est plus un aboutissement (demande
  // client du 30/09) ; sans JavaScript, l'action du <form> la sert encore.
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var target = results.querySelector(ACTIVE_SELECTOR) || results.querySelector(ROW_SELECTOR);
    if (target) window.location.assign(target.href);
  });

  drawer.addEventListener('click', function (event) {
    if (event.target.closest('[data-search-close]')) close();
  });

  // La loupe reste au-dessus du voile : elle ouvre ET referme, sinon le seul
  // moyen de sortir en cliquant dessus serait de la viser deux fois sans effet.
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-search-open]');
    if (!opener || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    if (drawer.hasAttribute('data-open')) close(); else open(opener);
  });

  // Rotation du téléphone ou fenêtre redimensionnée pendant la recherche : la
  // barre change de hauteur, le panneau doit rester collé dessous.
  window.addEventListener('resize', function () {
    if (drawer.hasAttribute('data-open')) syncOffset();
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer.hasAttribute('data-open')) return;

    if (event.key === 'Escape') {
      // Une recherche en cours se vide d'abord ; le tiroir ne se referme qu'une
      // fois le champ propre, pour ne pas faire disparaître la saisie ET le
      // tiroir d'un seul geste.
      if (input.value !== '') { input.value = ''; reset(); input.focus(); return; }
      close();
      return;
    }

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (!rows().length) return;
      event.preventDefault();
      move(event.key === 'ArrowDown' ? 1 : -1);
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')).filter(function (el) {
      return !el.closest('[inert]') && el.getClientRects().length > 0;
    });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (focusable.indexOf(document.activeElement) === -1) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
